import React from 'react';
import Rxlogo from '../../../images/logo-white.png';
import cvs from '../../../images/cvs-card.png';
import wg from '../../../images/walgreens.png';
import ra from '../../../images/rite-aid.png';
import kroger from '../../../images/kroger.png';
import wallmart from '../../../images/wallmart-card.png';
import AppleWallet from "../../../images/apple-wallet.svg";
import GoogleWallet from "../../../images/google-wallet.svg";
import './card-styles.css';

export function NuLifeSpanCardFront({ bin, pcn, groupNumber, memberId }) {
    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] prescription-card flex flex-col justify-between relative">
            {/* Side Icon */}
            <div className="absolute left-0 top-0 w-20 h-20 sm:w-[50px] sm:h-[50px] card-side-icon" />

            {/* Card Header */}
            <div className="pt-5 px-3.5 text-right">
                <img 
                    src={Rxlogo} 
                    alt="NuLifeSpan Rx Logo" 
                    className="max-w-[268px] lg:max-w-[188px] sm:max-w-[188px] ml-auto block" 
                />
                <h2 className="text-white font-normal text-2xl lg:text-base sm:text-base mt-2.5 mb-0 font-urbanist">
                    Prescription Discount Card
                </h2>
            </div>

            {/* Card Body */}
            <div className="flex justify-between items-end flex-wrap px-3.5 py-4">
                {/* Member Info */}
                <div className="w-[180px] max-w-[40%] sm:w-[170px] sm:max-w-[50%]">
                    <div className="text-white text-[22px] sm:text-xs font-urbanist">
                        Member ID 
                        <span className="block">{memberId}</span>
                    </div>
                    <p className="text-white text-base sm:text-base mt-0 font-urbanist">
                        Accepted at 35,000<br />pharmacies nationwide
                    </p>
                </div>

                {/* Card Info */}
                <div className="text-white font-normal w-[244px] max-w-[60%] text-[28px] leading-[1.3] sm:text-lg sm:w-[150px] sm:max-w-[50%] font-urbanist">
                    <div>Bin: <span>{bin}</span></div>
                    <div>PCN: <span>{pcn}</span></div>
                    <div>Group: <span>{groupNumber}</span></div>
                </div>
            </div>

            {/* Card Footer */}
            <div className="bg-[#f19f57] px-3.5 py-2.5 text-sm text-[#313131] font-normal flex justify-between items-end font-urbanist">
                <div className="w-[190px] max-w-[50%]">
                    Show this card to save up to 80% on your prescriptions
                </div>
                <div className="w-[270px] max-w-full">
                    <div className="font-bold mb-2 sm:mb-1.5">
                        This card is free. This is not insurance.
                    </div>
                    <p className="text-[#313131] text-sm">
                        Customer Service: 1-800-999-3053
                    </p>
                </div>
            </div>
        </div>
    );
}

export function NuLifeSpanCardBack({ 
    groupNumber, 
    memberId, 
    isLinked,
    deviceName,
    browserName,
    onAppleWalletClick,
    onGoogleWalletClick,
    linkDisabled
}) {
    const showAppleWallet = deviceName !== 'Android';
    const showGoogleWallet = deviceName !== 'iPhone';

    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] flex flex-col justify-between">
            {/* Card Body */}
            <div className="flex flex-wrap p-3 sm:p-2 pt-2.5 sm:pt-2.5 leading-none">
                <div className="w-full text-[11px] sm:text-[10px] flex flex-wrap text-white font-urbanist">
                    <div className="w-1/2 pl-1.5 mb-1.5 sm:mb-1 sm:pl-0">
                        <strong>Member Instructions</strong><br />
                        1. Present card to your pharmacist.<br />
                        2. Ask for discount on each prescription<br />
                        3. SAVE UP TO 80%*<br />
                        4. Use over and over! This card does not expire
                    </div>
                    <div className="w-1/2 pl-1.5 mb-1.5 sm:mb-1">
                        <strong>Instrucciones Miembros</strong><br />
                        1. Presente la tarjeta su farmaceutico<br />
                        2. Pedir descuento en cada recata<br />
                        3. AHORRE HASTA UN 80%**<br />
                        4. jUtilice una y otra vez! Esta tarjeta no caduca.
                    </div>
                    <div className="w-full mb-1.5 sm:mb-1">
                        <p className="mb-1.5 sm:mb-0.5 text-white font-urbanist">
                            *Prescription savings vary by prescription and by pharmacy, and may reach up to 80% off of the cash price. **Los ahorros en recetas varian segun la receta y la farmacia, y pueden alcanzar hasta un 80% de descuento sobre el precio en efectivo.
                        </p>
                        <p className="mb-1.5 sm:mb-0.5 text-white font-urbanist">
                            Visit nulifespanrx.com, download the NuLifeSpan Rx app, or call 800-984-4031 for more information, to report any concerns and to find participating pharmacies near you! The NuLifeSpan Rx Program, prices, list of covered drugs, and participating pharmacies are subject to change. By using this card, you have agreed to the terms and conditions found at NuLifeSpan Rx.com/terms. The NuLifeSpan Rx Program is provided by NuLifeSpan Rx LLC, PO Box 1703, Allen, TX 75013.
                        </p>
                    </div>
                    <div className="separator-line text-[11px] text-white mb-2 sm:mb-1 font-urbanist">
                        <span>This card is free. This is not insurance</span>
                    </div>
                </div>
            </div>

            {/* Card Footer */}
            <div className="text-[11px] sm:text-[10px] flex justify-between items-start flex-wrap bg-[#3b3d40] p-1.5 sm:p-2 font-urbanist">
                {/* Logos */}
                <div className="w-[290px] max-w-[60%] sm:w-[210px] sm:max-w-[55%] flex flex-wrap pr-px items-center justify-between mb-1.5 gap-1.5 sm:gap-0">
                    <img src={cvs} alt="CVS Pharmacy" className="max-w-[60px] max-h-[19px] sm:max-w-[35px]" />
                    <img src={wg} alt="Walgreens" className="max-w-[60px] max-h-[19px] sm:max-w-[35px]" />
                    <img src={ra} alt="Rite Aid" className="max-w-[60px] max-h-[19px] sm:max-w-[35px]" />
                    <img src={kroger} alt="Kroger" className="max-w-[60px] max-h-[19px] sm:max-w-[35px]" />
                    <img src={wallmart} alt="Walmart" className="max-w-[60px] max-h-[19px] sm:max-w-[35px]" />
                </div>

                {/* Right Info */}
                <div className="w-[180px] max-w-[40%] sm:max-w-[45%] text-right text-sm sm:text-[10px]">
                    <div className="flex flex-wrap justify-end items-end">
                        {showAppleWallet && (
                            <img 
                                className="w-[70px] sm:max-w-[50px] inline-block cursor-pointer" 
                                onClick={onAppleWalletClick}
                                src={AppleWallet} 
                                alt="Add to Apple Wallet" 
                            />
                        )}
                        {showGoogleWallet && (
                            <button 
                                disabled={linkDisabled}
                                className="inline-block ml-1 cursor-pointer disabled:pointer-events-none disabled:opacity-50"
                                onClick={onGoogleWalletClick}
                            >
                                <img 
                                    className="w-[70px] sm:max-w-[50px] block ml-0.5" 
                                    src={GoogleWallet} 
                                    alt="Add to Google Wallet" 
                                />
                            </button>
                        )}
                    </div>
                    <p className="mt-2.5 leading-[1.1] text-white font-urbanist">
                        {isLinked ? (
                            <>
                                <strong>www.nulifespanrx.com</strong><br />
                                &copy; NuLifeSpan Rx <strong>2018-2024</strong>
                            </>
                        ) : (
                            <>
                                <a href="https://nulifespanrx.com/" target="_blank" rel="noopener noreferrer" className="no-underline text-white">
                                    <strong>www.nulifespanrx.com</strong>
                                </a><br />
                                &copy; NuLifeSpan Rx <strong>2018-2024</strong>
                            </>
                        )}
                    </p>
                </div>

                {/* Instructions */}
                <div className="text-white w-full mt-1">
                    <h4 className="text-sm sm:text-[13px] font-semibold font-urbanist">Pharmacist Instructions</h4> 
                    <p className="text-[11px] sm:text-[10px] font-urbanist">This card is preactivated and gives member discounts through the BIN. PCN, GROUP on the front If you need assistance, call 811-800-7820</p>
                </div>
            </div>
        </div>
    );
}
